import { ClientSociety, ClientUser } from "@dune/types";
import { Button } from "@dune/ui";
import { ArrowRight } from "@untitled-ui/icons-react";
import { isClientUser } from "../../../utils/clients";

type SelectClientCardProps<T extends ClientUser | ClientSociety> = {
	client: T;
	onSelect: (client: T) => void;
};

const SelectClientCard = <T extends ClientUser | ClientSociety>({
	client,
	onSelect,
}: SelectClientCardProps<T>) => {
	return (
		<div className="flex flex-col justify-between border-solid border-1 border-gray-200 rounded-lg p-4 gap-4">
			{isClientUser(client) ? (
				<div className="flex flex-col">
					<div className="font-medium">
						{client.firstname} {client.lastname}
					</div>
					<div className="text-[#717680]">{client.email}</div>
					<div className="text-[#717680]">{client.mobilePhone}</div>
				</div>
			) : (
				<div className="flex flex-col">
					<div className="font-medium">{client.denomination}</div>
					<div className="text-[#717680]">{client.siren}</div>
				</div>
			)}

			<Button
				className="self-end bg-[#038EB7]"
				onClick={() => onSelect(client)}
			>
				Sélectionner
				<ArrowRight />
			</Button>
		</div>
	);
};

export default SelectClientCard;
